import { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';

import type { PortalProps } from './portal.props';

const Portal = ({ children }: PortalProps) => {
  const el = useMemo(() => document.createElement('div'), []);

  useEffect(() => {
    document.body.appendChild(el);

    return () => {
      document.body.removeChild(el);
    };
  }, [el]);

  return ReactDOM.createPortal(children, el);
};

export default Portal;
